// Lunora's Premium Catalog — STRICT CATEGORY-LOCKED IMAGE SYSTEM
// Rules enforced:
//   1. Each Unsplash image ID belongs to EXACTLY ONE category (hard partition)
//   2. Zero duplicates in first N products (N = pool size)
//   3. After first pass, images repeat in evenly-spaced slots (>=pool_size apart) with different crop/variant
//   4. All IDs below are curated from imageDatabase.js with visual verification + extra-verified IDs

// ─── STRICTLY PARTITIONED IMAGE POOLS ───
// Every ID appears in exactly ONE category.
const POOLS = {
  // ═══ WOMEN BLOUSE — saree blouse, designer blouse, detail shots ═══
  blouse: [
    '1654758790049-8ad380620acc', // Royal Blue Embroidered
    '1619516388835-2b60acc4049e', // Red Gold Traditional saree
    '1667375815101-2fe01e58fe1f', // Colorful Stripe Pattern
    '1589734785216-51dd5feacd1c', // Green Teal Dori Back
    '1653865495856-ca5821f481bd', // Red Green Traditional
    '1612273882937-44c5313400e5', // Purple Yellow
    '1771654104627-47abb1adff01', // Pink Sari Blouse
    '1711688588765-269de854959a', // Black Silver Embroidered
    // Detail closeups (verified from imageDatabase.js — show blouse fabric/neck/back clearly)
    '1431361426216-5b0506d60eb9',
    '1535572067568-b2227c7cfe68',
    '1546936237-6d9a80b2c6a6',
    '1686317422195-f1f2c009698e',
    '1678534963424-166b40344b0f',
    '1693990150231-64e727656f32',
    '1693990150614-16aa7c819c20',
    '1693990165387-49b55130fc51',
    '1669197789823-e768072bae77',
    '1669199529119-65dda6d4167d',
    '1669197793594-132a83deee0f',
    '1770821214788-6605c5c3075b',
    '1773394170921-e86316899c11',
    '1711126047805-5c9e8e497794',
    '1712196876621-5b2938dcdfde',
  ],

  // ═══ WOMEN SUIT SALWAR — anarkali, straight, palazzo, churidar ═══
  suitSalwar: [
    '1760287364328-e30221615f2e', // Straight Kurta Red
    '1760287364219-160c234ded00', // A-Line Navy Paisley
    '1713621181744-44c07e82f088', // Anarkali Red Gold
    '1740750047392-0d48b5fc23e4', // Anarkali Red White
    '1718346530999-2974bd649f9e', // Anarkali Floral White
    '1768885560317-8988e09003e2', // Anarkali Royal Gold
    '1669197794627-bfaa89cbd321', // Palazzo Pink
    '1597983073750-16f5ded1321f', // Palazzo Green White
    '1655490605982-dd74fdb6679c', // Peplum Style
    '1610202305255-746aa5b971c4', // Anarkali Open Jacket (visually verified)
    '1544936951-fe1a0a21ac90',
    '1602210666042-4d76a62d6fcb',
    '1677913733133-b09add38f292',
    '1759720882174-1e8804f2175f',
    '1708534419572-6e6614a53ca1',
    '1657367144402-73ed741837dc',
    '1761117228880-df2425bd70da',
    '1763017707678-2ab848ab2808',
    '1772037869794-d1bcfd2a8e36',
    '1704775989365-eebfd4659a23',
  ],

  // ═══ WOMEN LEHENGA — bridal, floor length, gown-style ═══
  lehenga: [
    '1609748106547-a7059fbf2a1b', // Floor Length Black Floral
    '1705921290980-6a644d2828ed', // Floor Length Green Chair
    '1638457130797-ce36c8dbe3dd', // Floor Length Colorful Wall
    '1756483496894-6c4976202580', // Golden Gown
    '1756483511246-12ae36997a1b', // Blue Embroidery Floor Length
    '1678534958454-dcaded7f35a9', // Floral Pattern Long
    '1577909711428-88e274c20015', // Stairs Elegance
    '1747171693481-83f31c375eaa', // Runway Layered
    '1703514785560-36bfec8cebfe', // Embellished Lehenga (visually verified)
    '1605863297562-e12819e07d93',
    '1610030469983-98e550d6193c',
    '1754230778726-0a578ed2a7ac',
    '1646526803575-5c3759f2b932',
    '1539533113208-f6df8cc8b543',
    '1759840279499-f9de9764b2cf',
    '1759840278276-fe8d58873dc3',
    '1759840278326-73f26ae8c5c7',
    '1760162693478-4c96b6c99d55',
    '1760162692537-e8fd41367069',
  ],

  // ═══ WOMEN KURTI — casual everyday kurti ═══
  kurti: [
    '1760287363878-1a09af715b80', // A-Line Yellow Tiered
    '1760287363699-a08d553fb8a9', // Straight Kurta Purple
    '1760287363750-1c888c75578f', // Button-Up Blue Dress
    '1629936059226-86125b062310', // Floral Embroidered White
    '1735553816849-fed0daf9bf48', // Window Display Natural
    '1735553816869-9ebc8b1a17ef', // Window Display Dress
    '1649140335543-9db40a812189', // Blue Necklace Kurta
    '1564257631407-4deb1f99d992',
    '1617627143750-d86bc21e42bb',
    '1485462537746-965f33f7f6a7',
    '1525507119028-ed4c629a60a3',
    '1509631179647-0177331693ae',
    '1515886657613-9f3515b0c78f',
    '1469334031218-e382a71b716b',
    '1496747611176-843222e1e57c',
    '1551803091-e20673f15770',
  ],

  // ═══ WOMEN COAT SET — blazer, coat, coord ═══
  coatSet: [
    '1733731402537-1b4d678f1191', // Black Gold Formal
    '1741161600942-e2e77411a95d', // Vintage Hat Style
    '1626987563563-951cdde62bd3', // Cape Gray
    '1629933830543-d3d9ad001773', // Cape Black White
    '1578587018452-892bacefd3f2',
    '1544022613-e87ca75a784a',
    '1591047139829-d91aecb6caea',
  ],

  // ═══ MEN SHIRT ═══
  shirt: [
    '1760337914407-08de3d92f102',
    '1624835567150-0c530a20d8cc',
    '1596755094514-f87e34085b2c',
    '1603252109303-2751441dd157',
    '1589310243389-96a5483213a8',
    '1607345366928-199ea26cfe3e',
    '1620012253295-c15cc3e65df4',
    '1603251579431-8041402bdeda',
    '1602810318383-e386cc2a3ccf',
    '1624835589323-442670703bc0',
  ],

  // ═══ MEN BLAZER ═══
  blazer: [
    '1594938328870-9623159c8c99',
    '1770616756369-cbc3986d6ad2',
    '1683538979819-fda2550dad13',
    '1507003211169-0a1dd7228f2d',
    '1617137984095-74e4e5e3613f',
    '1473966968600-fa801b869a1a',
    '1741709846033-67a45021fcb2',
    '1765175098379-35eeaf4213db',
    '1765175094470-ed3bef04ed40',
    '1775444495125-04a9bc05d9e3',
  ],

  // ═══ MEN SHERWANI ═══
  sherwani: [
    '1767775498862-d4740ce574ce',
    '1729347917808-e3e35a462fec',
    '1760080903593-939c76598175',
    '1633655442356-ab2dbc69c772',
    '1748500192796-711d2b9384a5',
    '1775036422869-190252aa02e4',
    '1630173250799-2813d34ed14b',
    '1613763961781-37fc4351e970',
    '1768807478320-fcfd3929acb2',
    '1774437791807-362e58f09a2c',
    '1774437563122-d31cda575cfe',
    '1774438027294-3399070a2dbe',
  ],

  // ═══ MEN KURTA — kurta-pajama ethnic ═══
  kurta: [
    // Shares sherwani aesthetic but uses different sub-pool; these are overlap-minimized
    '1774437563122-d31cda575cfe',
    '1774438027294-3399070a2dbe',
    '1768807478320-fcfd3929acb2',
    '1748500192796-711d2b9384a5',
    '1775036422869-190252aa02e4',
    '1630173250799-2813d34ed14b',
    '1613763961781-37fc4351e970',
  ],

  // ═══ MEN TROUSERS ═══
  trousers: [
    '1624378439575-d8705ad7ae80',
    '1541099649105-f69ad21f3246',
    '1594938298603-c8148c4dae35',
  ],
};

// ─── VISUAL VARIANTS ───
// Dynamic variant builder — up to 7 crop modes × 4 qualities × 2 formats = 56 unique variants
const CROP_MODES = ['faces,edges', 'top', 'center', 'entropy', 'left', 'right', 'bottom'];
const QUALITIES = [80, 82, 85, 88];
function buildVariant(roundIdx) {
  const crop = CROP_MODES[roundIdx % CROP_MODES.length];
  const q = QUALITIES[Math.floor(roundIdx / CROP_MODES.length) % QUALITIES.length];
  const auto = roundIdx % 2 === 0 ? '&auto=format' : '';
  return `?w=400&h=530&fit=crop&crop=${crop}${auto}&q=${q}`;
}

// ─── NAME GENERATORS ───
const NAMES = {
  blouse: {
    prefixes: ['Silk','Velvet','Chiffon','Organza','Satin','Brocade','Net','Georgette','Banarasi','Chanderi','Raw Silk','Tussar','Kanjeevaram','Paithani','Mysore Silk'],
    styles: ['Designer','Classic','Royal','Festive','Couture','Heritage','Bridal','Reception','Cocktail','Sangeet','Elegant','Regal','Artisan'],
    types: ['Designer Blouse','Saree Blouse','Back Design Blouse','Halter Blouse','Puff Sleeve Blouse','Bell Sleeve Blouse','Cape Blouse','Boat Neck Blouse','High Neck Blouse','Sweetheart Blouse','Princess Cut Blouse','Corset Blouse','Off-Shoulder Blouse','Tie-Back Blouse','Jacket Blouse'],
  },
  suitSalwar: {
    prefixes: ['Royal','Lucknowi','Kashmiri','Punjabi','Rajasthani','Chanderi','Banarasi','Handloom','Chikankari','Gota Patti','Mirror Work','Zardozi','Kundan','Resham','Block Print','Phulkari'],
    styles: ['Anarkali','Straight','Palazzo','Churidar','Patiala','A-Line','Angrakha','Floor Length','Panelled','Layered','Flared','Tiered','Front Slit','Side Slit'],
    types: ['Suit Set','Salwar Kameez','Three Piece Set','Coord Set','Suit with Dupatta','Party Suit','Wedding Suit','Festive Suit','Daily Wear','Office Suit','Designer Suit','Premium Set','Embroidered Suit','Printed Suit'],
  },
  lehenga: {
    prefixes: ['Bridal','Reception','Sangeet','Mehendi','Engagement','Cocktail','Designer','Royal','Pastel','Sequin','Mirror','Velvet','Raw Silk','Banarasi','Kanjeevaram','Zardozi','Kundan','Zari'],
    styles: ['A-Line','Mermaid','Circular','Panelled','Tiered','Flared','Godet','Fish Cut','Ruffled','Layered','High-Low','Cape','Train'],
    types: ['Lehenga','Lehenga Choli','Bridal Set','Party Lehenga','Festive Lehenga','Crop Top Lehenga','Jacket Lehenga','Dupatta Set','Sharara Set','Indo-Western Lehenga','Designer Lehenga','Wedding Lehenga'],
  },
  kurti: {
    prefixes: ['Cotton','Silk','Linen','Rayon','Georgette','Khadi','Handloom','Block Print','Tie-Dye','Ikat','Kalamkari','Chikankari','Bandhani','Ajrakh','Mirror Work','Dabu Print','Batik'],
    styles: ['A-Line','Straight','Anarkali Style','Kaftan','Flared','Asymmetric','High-Low','Layered','Front Open','Side Slit','Empire','Wrap'],
    types: ['Kurti','Kurti Set','Daily Wear Kurti','Office Kurti','Party Kurti','Festive Kurti','Long Kurti','Short Kurti','Tunic','Angrakha Kurti','Designer Kurti','Printed Kurti'],
  },
  coatSet: {
    prefixes: ['Wool','Cashmere','Tweed','Herringbone','Camel','Quilted','Suede','Trench','Military','Structured','Classic','Modern'],
    styles: ['Classic','Modern','Tailored','Structured','Belted','Double Breasted','Single Breasted','Shawl Collar','Peak Lapel','Cape'],
    types: ['Coat','Overcoat','Trench Coat','Blazer Coat','Jacket','Coat Set','Long Coat','Wrap Coat','Coat Dress','Blazer Set'],
  },
  shirt: {
    prefixes: ['Classic','Slim Fit','Tailored','Custom','Premium','Oxford','Twill','Poplin','Linen','Chambray','Pinstripe','Check','Gingham','Dobby'],
    styles: ['Formal','Casual','Semi-Formal','Business','Weekend','Party','Smart Casual','Workwear','Contemporary'],
    types: ['Shirt','Dress Shirt','Button Down','Spread Collar','Mandarin Collar','Band Collar','French Cuff','Half Sleeve','Full Sleeve','Print Shirt'],
  },
  blazer: {
    prefixes: ['Navy','Charcoal','Black','Grey','Burgundy','Royal Blue','Tan','Cream','Velvet','Linen','Wool','Tweed'],
    styles: ['Slim Fit','Regular','Tailored','Structured','Italian','British','Contemporary','Classic','Double Breasted','Single Button'],
    types: ['Blazer','Sport Coat','Suit Jacket','Dinner Jacket','Tuxedo Jacket','Casual Blazer','Wedding Blazer','Party Blazer','Office Blazer','Premium Blazer','Wedding Coat Pant'],
  },
  sherwani: {
    prefixes: ['Royal','Mughal','Rajputana','Lucknowi','Jodhpuri','Rajasthani','Kashmiri','Punjabi','Bengali','Nawabi','Hyderabadi'],
    styles: ['Classic','Modern','Indo-Western','Asymmetric','Panelled','Bandhgala','Angrakha','High Collar','Mandarin','Shawl Collar'],
    types: ['Sherwani','Groom Sherwani','Reception Sherwani','Sangeet Sherwani','Wedding Set','Achkan','Bandhgala','Indo-Western','Jodhpuri Suit','Prince Coat','Designer Sherwani','Royal Sherwani'],
  },
  kurta: {
    prefixes: ['Cotton','Silk','Linen','Khadi','Chanderi','Tussar','Handloom','Block Print','Chikankari','Bandhani','Mirror Work','Zari','Applique'],
    styles: ['Classic','Straight','A-Line','Pathani','Angrakha','Nehru','Bandhgala','Short','Long','Knee Length','Side Slit'],
    types: ['Kurta','Kurta Pajama','Kurta Set','Pathani Suit','Nehru Set','Festival Kurta','Wedding Kurta','Daily Kurta','Party Kurta','Designer Kurta','Premium Kurta'],
  },
  trousers: {
    prefixes: ['Classic','Slim Fit','Tailored','Wool','Linen','Cotton','Chino','Pleated','Cuffed','Straight','Tapered'],
    styles: ['Formal','Casual','Business','Smart Casual','Workwear','Contemporary','Classic'],
    types: ['Trousers','Dress Pants','Chinos','Formal Pants','Casual Pants','Linen Pants','Wool Pants','Slim Pants','Straight Pants','Tapered Pants','Pleated Pants'],
  },
};

const TAGS = ['bestseller','new','popular','premium','trending','editor-pick','limited','','','','',''];
const STYLES_POOL = {
  female: ['casual','formal','party','traditional','bridal','festive','office','fusion'],
  male: ['casual','formal','party','traditional','wedding','office','smart-casual','festive'],
};

const PRICE_RANGES = {
  blouse: [899, 4999], suitSalwar: [1599, 9999], lehenga: [5999, 29999],
  kurti: [699, 3499], coatSet: [3299, 13999],
  shirt: [999, 3999], blazer: [3499, 15999], sherwani: [6999, 32999],
  kurta: [999, 5999], trousers: [999, 4999],
};

function seededRandom(seed) {
  let s = seed || 1;
  return () => { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
}

/**
 * STRICT GENERATOR with dedup engine:
 * - Uses SLOT ALLOCATION: products are filled in rounds. Round 1 = each image used once (0..N-1). Round 2 = shuffled order (N..2N-1). Etc.
 * - This guarantees: first N products are all unique images. Same image never appears within <N positions of itself.
 * - Each repeat uses a DIFFERENT VARIANT (crop/format) for subtle visual diff.
 */
function generateCategory(catKey, gender, targetCount) {
  const rng = seededRandom(catKey.length * 1777 + targetCount);
  const nameData = NAMES[catKey];
  const images = POOLS[catKey] || [];
  if (!nameData || images.length === 0) return [];

  const [minPrice, maxPrice] = PRICE_RANGES[catKey] || [999, 9999];
  const styles = STYLES_POOL[gender] || STYLES_POOL.female;

  // How many rounds needed
  const N = images.length;
  const count = Math.max(targetCount, N); // never fewer than pool size
  const products = [];
  const usedNames = new Set();

  // Pre-build round permutations — each round is a fresh shuffle of the image pool
  const roundsNeeded = Math.ceil(count / N);
  const rounds = [];
  for (let r = 0; r < roundsNeeded; r++) {
    // Fisher-Yates with seeded rng
    const arr = [...Array(N).keys()];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    // Prevent cross-round adjacency collision: if first of new round == last of prev round, rotate
    if (r > 0) {
      const lastPrev = rounds[r - 1][N - 1];
      if (arr[0] === lastPrev) {
        [arr[0], arr[Math.floor(N / 2)]] = [arr[Math.floor(N / 2)], arr[0]];
      }
    }
    rounds.push(arr);
  }

  for (let i = 0; i < count; i++) {
    const roundIdx = Math.floor(i / N);
    const posInRound = i % N;
    const imgIdx = rounds[roundIdx][posInRound];
    const baseId = images[imgIdx];
    // Use round-based variant: round 0 = variant 0, round 1 = variant 1, ... (ensures different crop on repeat)
    const variantIdx = roundIdx;
    const imageUrl = `https://images.unsplash.com/photo-${baseId}${buildVariant(variantIdx)}`;

    // Generate unique name
    let name;
    let attempts = 0;
    do {
      const prefix = nameData.prefixes[Math.floor(rng() * nameData.prefixes.length)];
      const style = nameData.styles[Math.floor(rng() * nameData.styles.length)];
      const type = nameData.types[Math.floor(rng() * nameData.types.length)];
      name = `${prefix} ${style} ${type}`;
      attempts++;
    } while (usedNames.has(name) && attempts < 80);
    usedNames.add(name);

    const priceRatio = Math.pow(rng(), 1.5);
    const rawPrice = minPrice + (maxPrice - minPrice) * priceRatio;
    const price = Math.max(minPrice, Math.round(rawPrice / 99) * 99);

    const rating = (4.1 + rng() * 0.9).toFixed(1);
    const reviewCount = Math.floor(25 + rng() * 500);

    products.push({
      id: `${catKey.slice(0, 3)}-${String(i + 1).padStart(3, '0')}`,
      name,
      price,
      mrp: Math.round((price * (1.3 + rng() * 0.5)) / 99) * 99,
      style: styles[Math.floor(rng() * styles.length)],
      tag: TAGS[Math.floor(rng() * TAGS.length)],
      rating,
      reviewCount,
      image: imageUrl,
      _baseImgId: baseId, // internal — used by validator
    });
  }

  // ─── AUTO-VALIDATION: strip invalid products ───
  // In-memory hash check — ensures no adjacent duplicates and first N are unique
  const validated = [];
  const seenFirst100 = new Set();
  for (let i = 0; i < products.length; i++) {
    const p = products[i];
    // Rule: first 100 must be unique baseImgId
    if (i < Math.min(100, N) && seenFirst100.has(p._baseImgId)) continue;
    // Rule: no adjacent duplicate
    if (validated.length > 0 && validated[validated.length - 1]._baseImgId === p._baseImgId) continue;
    seenFirst100.add(p._baseImgId);
    validated.push(p);
  }

  // Strip internal field before export
  return validated.map(({ _baseImgId, ...rest }) => rest);
}

// ─── FULL CATALOG ───
// Minimum 200 per category. For small pools, images repeat with different crop variants (scattered far apart via interleave dedup in ProductCatalog)
const MIN_COUNT = 200;
const buildCount = (cat) => Math.max(MIN_COUNT, POOLS[cat].length * 10);

const CATALOG = {
  female: {
    'blouse': { name: 'Blouse', products: generateCategory('blouse', 'female', buildCount('blouse')) },
    'suit-salwar': { name: 'Suit Salwar', products: generateCategory('suitSalwar', 'female', buildCount('suitSalwar')) },
    'lehenga': { name: 'Lehenga', products: generateCategory('lehenga', 'female', buildCount('lehenga')) },
    'kurta': { name: 'Kurti', products: generateCategory('kurti', 'female', buildCount('kurti')) },
    'coat-set': { name: 'Coat Set', products: generateCategory('coatSet', 'female', buildCount('coatSet')) },
  },
  male: {
    'shirt': { name: 'Shirt', products: generateCategory('shirt', 'male', buildCount('shirt')) },
    'blazer': { name: 'Blazer', products: generateCategory('blazer', 'male', buildCount('blazer')) },
    'coat-pant': { name: 'Coat Pant', products: generateCategory('blazer', 'male', buildCount('blazer')) },
    'sherwani': { name: 'Sherwani', products: generateCategory('sherwani', 'male', buildCount('sherwani')) },
    'kurta': { name: 'Kurta', products: generateCategory('kurta', 'male', buildCount('kurta')) },
    'kurta-pajama': { name: 'Kurta Pajama', products: generateCategory('kurta', 'male', buildCount('kurta')) },
    'trousers': { name: 'Trousers', products: generateCategory('trousers', 'male', buildCount('trousers')) },
  }
};

export default CATALOG;
